var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWavingHandEmoji = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    fill: "none",
    viewBox: "0 0 80 80",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#975500",
    d: "M26.5 61.621a.64.64 0 0 1-.152-.022C21.1 60 15.416 54.263 14.182 49.324a.518.518 0 0 1 1.003-.253c1.138 4.555 6.604 10.052 11.464 11.539a.515.515 0 0 1-.148 1.011Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#975500",
    d: "M29.003 68.13a.54.54 0 0 1-.118-.014c-4.341-1.011-9.39-4.254-13.844-8.901-4.167-4.342-6.866-8.962-7.04-12.057a.514.514 0 0 1 .488-.545c.284-.018.532.2.545.488.157 2.816 2.807 7.288 6.752 11.399 4.32 4.507 9.18 7.641 13.335 8.61a.52.52 0 0 1 .388.623.521.521 0 0 1-.506.396Zm22.253-45.296a.517.517 0 0 1-.501-.384c-.728-2.763-4.037-6.73-7.049-7.506a.516.516 0 0 1-.37-.632.515.515 0 0 1 .632-.37c3.391.876 6.974 5.152 7.79 8.247a.517.517 0 0 1-.371.632.66.66 0 0 1-.13.013Zm6.526.92a.52.52 0 0 1-.502-.388C55.34 15.729 48.087 9.77 43.946 9.029a.519.519 0 0 1 .183-1.02c4.512.81 12.079 6.952 14.154 15.1a.515.515 0 0 1-.501.645"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_0a)",
    d: "M44.9 37.324c.833.92 1.583 2.127 1.265 2.445-.319.318-1.295-.257-2.04-1.007-.746-.745-2.529 7.188-2.703 7.59-.13.3-2.206 2.68-3.291 4.943-.362.754-.31 3.03-.445 3.164-.545.545-1.238.488-2.733-.832-1.495-1.321-2.271 6.547-.488 7.79 3.047 2.127 9.14 10.579 17.192 10.579 9.315 0 17.942-9.717 17.942-16.848 0-7.132-2.092-9.834-1.953-15.81.114-5.061 3.797-7.476 3.797-10.005 0-2.127-3.16-2.645-4.198-2.645-1.84 0-6.556 2.358-6.556 8.565 0 2.415-.689 4.599-3.16 4.599-2.472 0-5.231-3.391-6.9-6.037"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_1b)",
    d: "M71.439 29.334c0-1.156-.937-1.836-1.957-2.22 1.224 4.059-4.987 4.233-4.987 18.06s-8.052 17.85-11.386 18.544c-3.335.689-9.21.89-13.683-4.599-1.373-1.687-3.235-3.518-5.305-5.248-.877 1.46-1.064 6.565.344 7.545 3.047 2.128 9.141 10.58 17.192 10.58 9.316 0 17.942-9.717 17.942-16.848 0-7.132-2.092-9.834-1.953-15.81.114-5.061 3.793-7.476 3.793-10.005Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_2c)",
    d: "M34.953 53.627c-1.495-1.321-5.03-5.087-7.332-6.931-2.301-1.84-4.311-1.818-5.693.213-1.382 2.032 2.646 5.597 3.566 6.517 1.408 1.408 7.188 6.748 8.97 7.995"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_3d)",
    d: "M41.422 46.351c-.174.401-1.347.68-3.68-1.857-1.782-1.94-6.555-7.515-9.371-10.043-2.816-2.529-5.004-3.566-6.844-2.24-1.84 1.324-.793 4.08 1.264 6.38 2.546 2.847 5.475 5.75 8.278 8.54 2.193 2.18 7.158 6.787 6.613 7.332"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_4e)",
    d: "M31.073 47.127c2.071 2.058 6.605 6.273 6.652 7.201.654-1.02-.54-4.054-1.804-5.117-7.306-6.15-14.363-16.068-15.261-15.771-.384 1.443.588 3.422 2.131 5.152 2.546 2.842 5.475 5.75 8.282 8.535"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_5f)",
    d: "M50.624 33.819c-1.67-2.646-8.513-11.155-10.178-13.57-1.67-2.415-3.91-2.415-5.462-1.32-1.552 1.094-2.014 3.277 1.482 7.92 2.205 2.93 4.036 5.623 8.439 10.479l5.117-.357z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_6g)",
    d: "M44.125 38.762c-.746-.745-7.358-8.583-8.854-10.265-2.802-3.148-6.355-9.891-10.592-6.888-2.228 1.578-1.02 3.867-.388 4.786.632.92 8.853 10.41 9.66 11.212.806.806 7.645 8.339 7.475 8.74"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_7h)",
    d: "M44.9 37.323c.803.885 1.522 2.032 1.295 2.402 2.668-2.145-2.973-8.448-6.168-12.231-2.471-2.93-3.147-6.657-4.917-8.653-.044.026-.083.056-.126.083-1.552 1.094-2.014 3.278 1.482 7.92 2.201 2.93 4.036 5.628 8.434 10.48Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_8i)",
    d: "M33.946 37.611c.807.807 7.646 8.34 7.476 8.74 2.114-2.846-6.08-11.211-10.048-15.44-3.439-3.666-4.027-6.874-7.384-8.674-1.247 1.508-.257 3.356.296 4.163.633.92 8.858 10.41 9.66 11.211"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_9j)",
    d: "M41.27 46.522c-.24.148-.733.16-1.496-.28.567.458 1.09.633 1.495.28Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_10k)",
    d: "M67.729 27.55c1.757-.313 2.066-.113 1.752-.435-.854-.318-1.77-.427-2.24-.427-1.84 0-6.556 2.358-6.556 8.565 0 2.415-.689 4.599-3.165 4.599-.976 0-1.992-.527-2.973-1.33 4.342 4.809 7.746.28 8.265-2.824s-.235-7.223 4.917-8.147Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_11l)",
    d: "M34.452 19.395c-1.072 1.216-1.038 3.395 2.01 7.45 2.205 2.928 4.036 5.622 8.439 10.478.832.92 1.582 2.128 1.264 2.446.736-5.03-6.426-9.978-8.753-13.77-1.844-3.008-2.21-4.782-2.96-6.604"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_12m)",
    d: "M33.946 37.611c.807.807 7.646 8.34 7.476 8.74 1.508-1.076.48-2.755-1.853-5.087-4.782-4.782-11.438-11.207-14.114-16.499-.253-.501-.724-.872-1.277-.942-1.443-.187-.371 1.875.113 2.577.628.92 8.853 10.41 9.655 11.211"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_13n)",
    d: "M22.791 38.592c2.546 2.846 5.475 5.75 8.278 8.54 2.193 2.179 7.158 6.786 6.613 7.331 3.077-2.589-11.216-11.948-17.027-21.02-.379 1.435.593 3.418 2.136 5.149"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_14o)",
    d: "M37.054 54.978c.292-.113.445-.248.493-.397-.528.406-1.22.262-2.594-.954-1.495-1.321-5.03-5.087-7.332-6.931-1.011-.807-1.966-1.256-2.838-1.334 1.247.78.667 1.06 3.44 3.186 1.49 1.142 6.93 7.175 8.831 6.43"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_15p)",
    d: "M33.432 41.177c2.018 2.459 5.959 6.517 7.728 5.397-.488.165-1.6-.105-3.413-2.08-1.782-1.94-6.556-7.515-9.372-10.043-2.28-2.049-4.15-3.117-5.754-2.746 4.669 1.534 8.897 7.149 10.81 9.472Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_16q)",
    d: "M35.616 30.598c3.221 3.504 8.003 10.457 10.427 9.24-.397.123-1.251-.405-1.918-1.076-.746-.745-7.358-8.583-8.854-10.265-1.944-2.18-4.241-6.086-6.883-7.28 2.664 2.1 4.617 6.543 7.228 9.38Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_17r)",
    d: "M54.547 38.527q.0075 0 0 0c-1.504-1.23-2.916-3.108-3.927-4.708-1.665-2.646-8.51-11.155-10.174-13.57-.51-.737-1.068-1.247-1.648-1.57.776 1.117 1.216 2.708 2.973 4.678 2.816 3.16 6.5 8.853 7.763 10.81 1.26 1.949 3.3 6.073 5.013 4.36"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_18s)",
    d: "M63.771 66.59c-1.046-2.545-2.576-4.097-4.786-2.641-6.029 3.971-12.964 2.629-21.66-4.398-7.755-6.273-11.766-10.754-15.54-12.376-.907 2.062 2.824 5.37 3.705 6.251 1.408 1.408 7.188 6.748 8.97 7.995C37.509 63.548 43.603 72 51.654 72c4.503-.005 8.836-2.267 12.118-5.41Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_19t)",
    d: "M67.642 39.337c.113-5.06 3.797-7.475 3.797-10.004 0-.745-.388-1.29-.938-1.686.672 1.97-.928 3.718-3.317 6.69-2.589 3.222-3.16 8.222-1.382 13.226 1.783 5.004-.462 11.905-4.084 14.089s-8.435 11.787-22.214.937l-.009-.009c-.84-.78-1.673-1.473-2.515-1.996-5.82-3.605-9.136-6.848-11.643-9.573-.492-.536-1.818-2.59-3.396-1.914.79 1.788 2.912 3.693 3.549 4.33 1.408 1.407 7.188 6.747 8.97 7.994.232.16.484.361.75.593l.21.182c.017.018.039.035.056.049l.136.122c.008.008.021.017.03.03 1.809 1.643 4.298 4.363 7.35 6.486a20 20 0 0 0 .82.55c.003.004.008.004.012.008.275.175.554.345.833.506.004 0 .004.004.008.004 2.11 1.212 4.45 2.05 6.98 2.05 9.314 0 17.941-9.717 17.941-16.849 0-7.131-2.08-9.834-1.944-15.815"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_0a",
    x1: 65.07,
    x2: 57.394,
    y1: 73.841,
    y2: 55.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#FFCB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_1b",
    x1: 66.598,
    x2: 50.498,
    y1: 61.333,
    y2: 42.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#FFCB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_2c",
    x1: 23.564,
    x2: 33.052,
    y1: 48.547,
    y2: 55.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#FFCB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_3d",
    x1: 20.11,
    x2: 36.756,
    y1: 30.055,
    y2: 47.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#FFCB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_4e",
    x1: 32.889,
    x2: 27.386,
    y1: 40.401,
    y2: 45.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA754"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_5f",
    x1: 38.09,
    x2: 47.749,
    y1: 21.835,
    y2: 37.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#FFCB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_6g",
    x1: 28.118,
    x2: 41.228,
    y1: 24.357,
    y2: 42.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#FFCB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_7h",
    x1: 43.71,
    x2: 35.43,
    y1: 26.494,
    y2: 33.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA754"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_8i",
    x1: 36.093,
    x2: 24.708,
    y1: 31.82,
    y2: 40.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA754"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_9j",
    x1: 44.574,
    x2: 33.189,
    y1: 43.421,
    y2: 51.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA754"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_11l",
    x1: 45.225,
    x2: 38.152,
    y1: 25.026,
    y2: 31.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_12m",
    x1: 39.809,
    x2: 30.494,
    y1: 28.579,
    y2: 36.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_13n",
    x1: 36.661,
    x2: 25.161,
    y1: 37.659,
    y2: 47.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_14o",
    x1: 24.113,
    x2: 37.482,
    y1: 44.677,
    y2: 55.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_15p",
    x1: 26.672,
    x2: 37.108,
    y1: 31.206,
    y2: 47.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_16q",
    x1: 34.846,
    x2: 37.779,
    y1: 32.34,
    y2: 30.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA754"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_17r",
    x1: 49.317,
    x2: 45.407,
    y1: 41.199,
    y2: 22.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_18s",
    x1: 40.392,
    x2: 34.527,
    y1: 59.08,
    y2: 64.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8900"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg_10k",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(59.513 29.908)scale(13.6681)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA754"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg_19t",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(26.43741 29.5065 -26.78262 23.99685 44.276 41.264)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.613,
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8900"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWavingHandEmoji);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/waving-hand-emoji.a7a58eca822cce9cdb96782a6caf9e2d.svg";